import React from 'react';
import { Link } from 'react-router-dom';

const NotFound = () => {
  return (
    <div 
      className="min-h-screen flex flex-col items-center justify-center text-white"
      style={{
        background: "url('/imgs/bg-galaxy.webp')",
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
        backgroundBlendMode: "overlay",
        backgroundColor: "rgba(0, 0, 0, 0.8)",
      }}
    >
      <div className="text-center px-4 py-8 rounded-lg backdrop-blur-sm bg-black/30">
        <h1 className="text-8xl font-bold text-primary mb-4">404</h1>
        <h2 className="text-3xl font-semibold text-white mb-6">Page Not Found</h2>
        <p className="text-gray-300 mb-8 text-center max-w-md">
          The page you are looking for might have been removed, had its name changed, or is temporarily unavailable.
        </p>
        <Link 
          to="/" 
          className="px-6 py-3 bg-primary text-white rounded-md hover:bg-primary-light transition-colors"
        >
          Return to Home
        </Link>
      </div>
    </div>
  );
};

export default NotFound; 